import { type FC } from "react";

import { ChartActions } from "~/feature/chart/components/ChartActions";
import { ChartViewMode } from "~/feature/chart/components/ChartViewMode";
import { MarketsDropdown } from "~/feature/chart/components/MarketsDropdown";
import { useCoreChart } from "~/feature/chart/providers/CoreChartProvider";
import { ChartViewEnum } from "~/feature/chart/types";

import * as Styled from "./TopBar.styles";

export const TopBar: FC = () => {
  const { markets, selections, viewMode, setSelections, setViewMode } =
    useCoreChart();

  return (
    <Styled.Root>
      <MarketsDropdown
        markets={markets}
        selections={selections}
        isConsensusMode={viewMode === ChartViewEnum.CONSENSUS}
        onToggle={setSelections}
        onSelectConsensus={(marketId) =>
          setViewMode(ChartViewEnum.CONSENSUS, marketId)
        }
      />
      <ChartViewMode />
      <ChartActions />
    </Styled.Root>
  );
};
